module.exports = __webpack_public_path__ + "img/180.34d48de6.jpg";